export default "__VITE_ASSET__9JPKPe8C__"